<div class="apto-form-control-help">
    <apto-help-text [error]="error">
        <ng-content></ng-content>
    </apto-help-text>
</div>